import { DeskDocument } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export interface ExtendedDeskDocument extends DeskDocument {
  folderId?: number;
}

export const DocumentToolkitObject =
  registerToolkitObjectType<ExtendedDeskDocument>('document');
